import { Vue, Component , Prop } from 'vue-property-decorator'


@Component
export default class LoadList extends Vue {
  @Prop() readonly current!: number
  @Prop() readonly index!:number //只有current===index时 才显示筛选框

    loading = true  //是否显示loading
    finished = false  //是否加载更多结束
    error = false  //加载更多时 是否显示错误
    start = 0  //开始游标
    list: any[] = []  //数据源
    keyWord = ''  //关键字
    errormsg = ''  //错误日志
    tabs = ''
    isFixed = false
    scrollTop = 0
 
    
    //重置数据
    reset() {
        this.list = []
        this.start = 0
        this.errormsg = ''
        this.finished = false
        this.loading = true
        this.error = false
  }
  
  scroll(param: any) {
    const { scrollTop , isFixed } = param
    if (!this.isFixed && isFixed) {
       this.scrollTop = scrollTop
     }
     this.isFixed = isFixed
  }
    
}